import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { SortableTableColumnHeader, Pagination } from 'sarsaparilla';
import { fetchAssets } from '../../actions/asset';
import { saveSearch } from '../../actions/search';
import { AssetProps } from '../../props/asset';
import { CurrentUserProps } from '../../props/currentUser';
import { SearchProps } from '../../props/search';
import { getAssets, getAssetCount } from '../../reducers/assets';
import { getCurrentUser } from '../../reducers/currentUser';
import { getSearch } from '../../reducers/search';
import SearchForm from '../SearchForm';

import styles from './SearchPage.scss';

const propTypes = {
  currentUser: CurrentUserProps,
  searchQuery: SearchProps,
  assets: PropTypes.arrayOf(AssetProps),
  assetCount: PropTypes.number,
  saveSearch: PropTypes.func.isRequired,
  fetchAssets: PropTypes.func.isRequired
};

export class SearchPage extends Component {
  constructor(props) {
    super(props);

    this.state = {};

    this.setSort = this.setSort.bind(this);
    this.setPage = this.setPage.bind(this);
    this.goSearch = this.goSearch.bind(this);

    this.renderAssetLink = this.renderAssetLink.bind(this);
    this.renderExportLink = this.renderExportLink.bind(this);
  }

  componentDidMount() {
    this.goSearch();
  }

  setSort(isSorted, isAsc, column) {
    this.props.saveSearch({ ...this.props.searchQuery, sort: `${isAsc ? '' : '-'}${column}` })
      .then(this.goSearch);
  }

  setPage(page) {
    this.props.saveSearch({ ...this.props.searchQuery, page })
      .then(this.goSearch);
  }

  goSearch() {
    this.props.fetchAssets(this.props.searchQuery)
      .catch(console.log); // TODO Handle failures
  }

  renderAssetLink(asset) {
    const { id, type, name } = asset;

    let partial;

    if (name === '') {
      return null;
    }

    switch (type) {
      case 'RecArea':
      case 'Rec Area':
        partial = '/camping/gateways/';
        break;
      case 'Campground':
        partial = '/camping/campgrounds/';
        break;
      default:
        partial = '/camping/poi/';
    }

    const link = [
      process.env.SITE_ROOT,
      partial,
      id
    ].join('');

    return (<a target="_blank" rel="noopener noreferrer" href={link}>{name}</a>);
  }

  renderExportLink(asset) {
    const { loggedIn, isDeveloper, apiKey: { apiKey } } = this.props.currentUser;

    if (!isDeveloper) {
      return (<Link to="/profile">Request an ApiKey</Link>);
    }

    if (!loggedIn) {
      return (<Link to="/login">Login to View</Link>);
    }

    const link = [
      process.env.RIDB_ROOT,
      '/api/v1',
      asset.type === 'Rec Area' ? '/recareas/' : '/facilities/',
      asset.id,
      '?full=true',
      '&apikey=',
      apiKey
    ].join('');

    return (<a target="_blank" rel="noopener noreferrer" href={link}>JSON</a>);
  }

  render() {
    const { assets, assetCount, searchQuery: { sort, limit, page } } = this.props;
    const isAsc = !/^-/.test(sort);
    const pages = Math.ceil(assetCount / limit);

    return (
      <main role="main" className={styles['search-page']}>
        <h1>Advanced RIDB Search</h1>
        <SearchForm onSearch={this.goSearch} inline showLimitSelect searchOnChange />
        {/* Search results table */}
        <div className={`${styles['search-results-table']} ${styles['margin-bottom']}`}>
          <table className="table-no-border">
            <thead>
              <tr>
                <SortableTableColumnHeader
                  name="Name"
                  id="name"
                  isSorted={/name/.test(sort)}
                  isAsc={/name/.test(sort) && isAsc}
                  onSortToggle={this.setSort} />
                <SortableTableColumnHeader
                  name="Type"
                  id="type"
                  isSorted={/type/.test(sort)}
                  isAsc={/type/.test(sort) && isAsc}
                  onSortToggle={this.setSort} />
                <SortableTableColumnHeader
                  name="Organization"
                  id="org_name"
                  isSorted={/org_name/.test(sort)}
                  isAsc={/org_name/.test(sort) && isAsc}
                  onSortToggle={this.setSort} />
                <th>Export</th>
              </tr>
            </thead>
            <tbody>
              {assets.map((asset) => (
                <tr key={asset.id}>
                  <td>{this.renderAssetLink(asset)}</td>
                  <td>{asset.type}</td>
                  <td>{asset.org_name}</td>
                  <td>{this.renderExportLink(asset)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className={`${styles['align-right']} ${styles['margin-bottom']}`}>
          <Pagination onChange={this.setPage} activePage={page} pages={pages} wings={2} />
        </div>

        {/* Notice box */}
        <div className={styles['info-box']}>
          <h3>Notice:</h3>
          <ul>
            <li><strong>Please DO NOT share these links as they contain your personal API Key.</strong></li>
            <li>
              For more information on how to use the RIDB data, please visit our
              <Link to="/docs">API Documentation</Link>.
            </li>
            <li>Export All results may include additional Recreation Areas or Facilities as the API queries additional
              fields.
            </li>
          </ul>
        </div>
      </main>
    );
  }
}

SearchPage.propTypes = propTypes;

const mapStateToProps = (state) => ({
  currentUser: getCurrentUser(state),
  searchQuery: getSearch(state),
  assets: getAssets(state),
  assetCount: getAssetCount(state)
});

const mapDispatchToProps = (dispatch) => bindActionCreators({ saveSearch, fetchAssets }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(SearchPage);
